import IRIAsphalt from "../../img/info/IRI_Asphalt.png";
import "./Information.css";

const IRIAsphaltPage = () => {
    return (
      <div className="info_container">
        <h1>International Roughness Index (IRI) Modeling for Apshalt Pavement</h1>
        <h2>Role of IRI to Asphalt Pavement</h2>
        <ul>
            <li>IRI is critical for traffic safety, driving comfort, and fuel efficiency.</li>
            <li>It is widely used indicator of pavement roughness.</li>
            <li>Accurate IRI forecasting is essential for the design, maintenance, and management of asphalt pavements.</li>
        </ul>
        <figure className="figure">
                <img src={IRIAsphalt} alt="IRI of Asphalt" />
                <figcaption>Figure 1 Mechanistic-Empirical-Based IRI modeling for asphalt pavement using Artificial Neural Networks. [1]</figcaption>
        </figure>
            <h2>Proposed Approach</h2>
        <ul>
            <li>A novel framework is introduced to develop surrogate Artificial Neural Network (ANN) models based on Pavement ME simulations.</li>
            <li>The framework supports a wide range of design variables, enhancing usability across diverse climates and regions in the United States.</li>
        </ul>
            <h2>Key Findings:</h2>
       
        <ul>
                <li>ANN models demonstrated high accuracy in predicting transverse cracking, mean joint fauling and IRI.</li>
                <li>Surrogate ANN models provide an efficient and computationally affordable alternative to Pavement ME.</li>
                <li>The framework ensures robust predictive accuracy across diverse scenarios, facilitating nationwide implementation of MEPDG-based designs.</li>
            </ul>
            <div className="info_ref-block">
                <p>[1] Li, H., Azarijafari, H., Kirchain, R., Santos, J., Khazanovich, L. (2024). Surrogate Modelling of Surface Roughness for Asphalt Pavements Using Artificial Neural Networks: A Mechanistic-Empirical Approach. International Journal of Pavement Engineering, 25(1), 2434909, doi: 10.1080/10298436.2024.2434909.</p>
            </div>
      </div>
    );
  }
  
  export default IRIAsphaltPage;